module.exports = __webpack_public_path__ + "static/media/ccl-black.d45b6760.png";